<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_vii"></a>For my parents and Eva</p>
<p class="noindent"><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?0a90dcee